module.exports = __webpack_public_path__ + "static/thermowells-809fae5c226ef1cc017a1b42cf843888.jpg";